import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getHomePathForRole } from "../modules/registry";
import { PORTAL_NAME } from "../constants/brand";
import { RotatingShieldLogo } from "./shared/RotatingShieldLogo";

export function ProtectedRoute({ roles, requireModule, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen bg-igc-bg flex flex-col items-center justify-center gap-4">
        <RotatingShieldLogo size={64} />
        <div className="text-igc-goldText font-serif text-xl" data-testid="auth-loading">
          {PORTAL_NAME}
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (!user._impersonating && user.must_change_password && location.pathname !== "/set-password") {
    return <Navigate to="/set-password" replace />;
  }
  if (
    !user._impersonating &&
    !user.must_change_password &&
    ["client", "affiliate"].includes(user.role) &&
    user.profile_complete === false &&
    location.pathname !== "/client/complete-profile"
  ) {
    return <Navigate to="/client/complete-profile" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={getHomePathForRole(user.role)} replace />;
  }
  if (requireModule && user.role === "client" && !(user.unlocked_modules || []).includes(requireModule)) {
    return <Navigate to="/client" replace />;
  }
  return children;
}
